var CONTINUOUS_MEASURE_TO_PIVOT, DEFAULT_CI_LEVEL, DOSE_RESPONSE_TO_PIVOT, DOWNGRADE_NAME_TO_PIVOT, FOLLOW_UP_UNITS, GRADEPRO_AUTHORITY, GRADEPRO_CONTINUOUS_OTHER_MEASURES, GRADEPRO_RELATIVE_OTHER_MEASURES, IMPORTANCE_TO_PIVOT, LARGE_EFFECT_TO_PIVOT, OUTCOME_TYPE_TO_PIVOT, PIVOT_DOSE_RESPONSE_TO_SCORE, PIVOT_DOWNGRADE_TO_SCORE, PIVOT_LARGE_EFFECT_TO_SCORE, PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE, PIVOT_PUBLICATION_BIAS_TO_SCORE, PIVOT_RELATIVE_MEASURE_TO_GDT, PIVOT_TO_IMPORTANCE, PIVOT_TO_OUTCOME_TYPE, PIVOT_TO_QUALITY, PLAUSIBLE_CONFOUNDING_TO_PIVOT, PUBLICATION_BIAS_TO_PIVOT, QUALITY_TO_PIVOT, QualityScores, RELATIVE_MEASURE_TO_PIVOT, SCHEMA_URI, STUDY_TYPE_NON_RANDOMIZED, STUDY_TYPE_RANDOMIZED;

QualityScores = require('models/outcome/quality_scores');

GRADEPRO_AUTHORITY = 'https://gradepro.org';

SCHEMA_URI = 'https://assets.cochrane.org/schema/v1/sof/summary-of-findings.schema.json';

IMPORTANCE_TO_PIVOT = {
  1: 'UNIMPORTANT1',
  2: 'UNIMPORTANT2',
  3: 'UNIMPORTANT3',
  4: 'IMPORTANT4',
  5: 'IMPORTANT5',
  6: 'IMPORTANT6',
  7: 'CRITICAL7',
  8: 'CRITICAL8',
  9: 'CRITICAL9'
};

PIVOT_TO_IMPORTANCE = _.invert(IMPORTANCE_TO_PIVOT);

QUALITY_TO_PIVOT = {
  4: 'HIGH',
  3: 'MODERATE',
  2: 'LOW',
  1: 'VERY_LOW'
};

PIVOT_TO_QUALITY = _.invert(QUALITY_TO_PIVOT);

OUTCOME_TYPE_TO_PIVOT = {
  dich: 'DICHOTOMOUS',
  cont: 'CONTINUOUS',
  narrative: 'NARRATIVE',
  time_to_event: 'DICHOTOMOUS'
};

PIVOT_TO_OUTCOME_TYPE = {
  DICHOTOMOUS: 'dich',
  CONTINUOUS: 'cont',
  NARRATIVE: 'narrative',
  OTHER_NUMERIC: 'dich'
};

RELATIVE_MEASURE_TO_PIVOT = {
  RR: 'RR',
  OR: 'OR',
  HR: 'HR',
  RD: 'RD',
  IRR: 'IRR',
  rateRatio: 'IRR',
  POR: 'POR',
  PE: 'PE',
  RateRatio: 'IRR',
  RATE_RATIO: 'IRR'
};

PIVOT_RELATIVE_MEASURE_TO_GDT = {
  RR: {
    effectMeasure: 'RR'
  },
  OR: {
    effectMeasure: 'OR'
  },
  HR: {
    effectMeasure: 'HR'
  },
  IRR: {
    effectMeasure: 'rateRatio'
  },
  RD: {
    effectMeasure: 'other',
    otherMeasure: 'RD'
  },
  POR: {
    effectMeasure: 'other',
    otherMeasure: 'POR'
  },
  PE: {
    effectMeasure: 'other',
    otherMeasure: 'PE'
  },
  OTHER: {
    effectMeasure: 'other'
  }
};

GRADEPRO_RELATIVE_OTHER_MEASURES = ['VEOR', 'VEHR', 'RR', 'OR', 'HR', 'rateRatio'];

GRADEPRO_CONTINUOUS_OTHER_MEASURES = ['MD', 'SMD', 'mean', 'median'];

CONTINUOUS_MEASURE_TO_PIVOT = {
  MD: 'MD',
  SMD: 'SMD'
};

FOLLOW_UP_UNITS = ['days', 'weeks', 'months', 'years', 'hours', 'patientYears'];

DOWNGRADE_NAME_TO_PIVOT = {
  ExtremelySerious: 'EXTREMELY_SERIOUS',
  VerySerious: 'VERY_SERIOUS',
  Serious: 'SERIOUS',
  None: 'NOT_SERIOUS'
};

PIVOT_DOWNGRADE_TO_SCORE = {
  EXTREMELY_SERIOUS: QualityScores.ExtremelySerious,
  VERY_SERIOUS: QualityScores.VerySerious,
  SERIOUS: QualityScores.Serious,
  NOT_SERIOUS: QualityScores.None
};

PUBLICATION_BIAS_TO_PIVOT = {
  Serious: 'SERIOUS',
  VerySerious: 'SERIOUS',
  ExtremelySerious: 'SERIOUS',
  None: 'NOT_SERIOUS'
};

PIVOT_PUBLICATION_BIAS_TO_SCORE = {
  SERIOUS: QualityScores.Serious,
  NOT_SERIOUS: QualityScores.None
};

LARGE_EFFECT_TO_PIVOT = {
  VeryLarge: 'VERY_LARGE',
  Large: 'LARGE',
  None: 'NO',
  No: 'NO'
};

PIVOT_LARGE_EFFECT_TO_SCORE = {
  VERY_LARGE: QualityScores.VeryLarge,
  LARGE: QualityScores.Large,
  NO: QualityScores.No
};

DOSE_RESPONSE_TO_PIVOT = {
  Yes: 'YES',
  Large: 'YES',
  None: 'NO',
  No: 'NO'
};

PIVOT_DOSE_RESPONSE_TO_SCORE = {
  YES: QualityScores.Yes,
  NO: QualityScores.No
};

PLAUSIBLE_CONFOUNDING_TO_PIVOT = {
  IncreasedForRR: 'YES',
  ReducedForRR: 'YES',
  None: 'NO',
  No: 'NO',
  Yes: 'YES'
};

PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE = {
  YES: QualityScores.IncreasedForRR,
  NO: QualityScores.No
};

STUDY_TYPE_RANDOMIZED = 'RANDOMIZED';

STUDY_TYPE_NON_RANDOMIZED = 'NON_RANDOMIZED';

DEFAULT_CI_LEVEL = 0.95;

module.exports = {
  GRADEPRO_AUTHORITY: GRADEPRO_AUTHORITY,
  SCHEMA_URI: SCHEMA_URI,
  IMPORTANCE_TO_PIVOT: IMPORTANCE_TO_PIVOT,
  PIVOT_TO_IMPORTANCE: PIVOT_TO_IMPORTANCE,
  QUALITY_TO_PIVOT: QUALITY_TO_PIVOT,
  PIVOT_TO_QUALITY: PIVOT_TO_QUALITY,
  OUTCOME_TYPE_TO_PIVOT: OUTCOME_TYPE_TO_PIVOT,
  PIVOT_TO_OUTCOME_TYPE: PIVOT_TO_OUTCOME_TYPE,
  RELATIVE_MEASURE_TO_PIVOT: RELATIVE_MEASURE_TO_PIVOT,
  PIVOT_RELATIVE_MEASURE_TO_GDT: PIVOT_RELATIVE_MEASURE_TO_GDT,
  GRADEPRO_RELATIVE_OTHER_MEASURES: GRADEPRO_RELATIVE_OTHER_MEASURES,
  GRADEPRO_CONTINUOUS_OTHER_MEASURES: GRADEPRO_CONTINUOUS_OTHER_MEASURES,
  CONTINUOUS_MEASURE_TO_PIVOT: CONTINUOUS_MEASURE_TO_PIVOT,
  FOLLOW_UP_UNITS: FOLLOW_UP_UNITS,
  DOWNGRADE_NAME_TO_PIVOT: DOWNGRADE_NAME_TO_PIVOT,
  PIVOT_DOWNGRADE_TO_SCORE: PIVOT_DOWNGRADE_TO_SCORE,
  PUBLICATION_BIAS_TO_PIVOT: PUBLICATION_BIAS_TO_PIVOT,
  PIVOT_PUBLICATION_BIAS_TO_SCORE: PIVOT_PUBLICATION_BIAS_TO_SCORE,
  LARGE_EFFECT_TO_PIVOT: LARGE_EFFECT_TO_PIVOT,
  PIVOT_LARGE_EFFECT_TO_SCORE: PIVOT_LARGE_EFFECT_TO_SCORE,
  DOSE_RESPONSE_TO_PIVOT: DOSE_RESPONSE_TO_PIVOT,
  PIVOT_DOSE_RESPONSE_TO_SCORE: PIVOT_DOSE_RESPONSE_TO_SCORE,
  PLAUSIBLE_CONFOUNDING_TO_PIVOT: PLAUSIBLE_CONFOUNDING_TO_PIVOT,
  PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE: PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE,
  STUDY_TYPE_RANDOMIZED: STUDY_TYPE_RANDOMIZED,
  STUDY_TYPE_NON_RANDOMIZED: STUDY_TYPE_NON_RANDOMIZED,
  DEFAULT_CI_LEVEL: DEFAULT_CI_LEVEL
};
